import { z } from "zod";

export const magicLinkRequestSchema = z.object({
  email: z.email(),
});

export const magicLinkVerifySchema = z.object({
  token: z.string().min(1),
});

export const accountTypeSchema = z.object({
  accountType: z.enum(["user", "business"]),
});

export const updateUserSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  avatarUrl: z.url().optional().nullable(),
});

export type MagicLinkRequest = z.infer<typeof magicLinkRequestSchema>;
export type MagicLinkVerify = z.infer<typeof magicLinkVerifySchema>;
export type AccountTypeInput = z.infer<typeof accountTypeSchema>;
export const passkeyVerifySchema = z.object({
  challengeId: z.string().min(1),
  credential: z.object({
    id: z.string(),
    rawId: z.string(),
    response: z.record(z.string(), z.unknown()),
    type: z.literal("public-key"),
    clientExtensionResults: z.record(z.string(), z.unknown()).optional(),
    authenticatorAttachment: z.string().optional(),
  }),
});

export type UpdateUserInput = z.infer<typeof updateUserSchema>;
export type PasskeyVerifyInput = z.infer<typeof passkeyVerifySchema>;
